import { ICardForm } from '@entities/card/types';
import * as S from './styles';
import { FC, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { CopyOutlined } from '@ant-design/icons';

interface CardFormProps {
    form: ICardForm;
    modalVisibilityToggler: () => void;
}

export const CreateCardFormModal: FC<CardFormProps> = ({
    form,
    modalVisibilityToggler,
}) => {
    const [showQr, setShowQr] = useState<boolean>(false);
    const [copyStatus, setCopyStatus] = useState<string>('');

    const getRedirectUrl = (): string => {
        if (form.link) {
            return form.link;
        }
        return form.url || '#';
    };

    const handleGenerateQr = (): void => {
        setShowQr(true);
    };

    const getQrUrl = (): string => {
        return getRedirectUrl();
    };

    const handleCopyLink = async (): Promise<void> => {
        const url = getRedirectUrl();

        if (!url) {
            setCopyStatus('Ссылка недоступна');
            setTimeout(() => setCopyStatus(''), 2000);
            return;
        }

        try {
            await navigator.clipboard.writeText(url);
            setCopyStatus('Скопировано!');
        } catch {
            setCopyStatus('Ошибка копирования');
        }

        setTimeout(() => setCopyStatus(''), 5000);
    };

    return (
        <S.Wrapper>
            <S.CloseBtn onClick={modalVisibilityToggler}>Закрыть</S.CloseBtn>
            <S.BlurredContent>
                <S.Title>{form?.name}</S.Title>
                <S.SubTitle>{form?.desc}</S.SubTitle>
                <S.BtnWrapper>
                    <S.StyledButtonLink onClick={handleCopyLink}>
                        <span> {copyStatus || 'Скопировать ссылку'}</span>
                        <CopyOutlined />
                    </S.StyledButtonLink>
                    <S.StyledButtonQr onClick={handleGenerateQr}>
                        <span>Сформировать QR код</span>
                    </S.StyledButtonQr>
                </S.BtnWrapper>

                {showQr && (
                    <S.QrWrapper>
                        <QRCodeCanvas value={getQrUrl()} size={200} level="M" />
                        <S.QrText>QR код для формы</S.QrText>
                    </S.QrWrapper>
                )}
            </S.BlurredContent>
        </S.Wrapper>
    );
};
